import SmallContainer from '@components/ui/layout/SmallContainer'
import { Heading, Text } from '@components/ui/typography'
import { FadeInChild } from '@components/_home/FadeInChild'
import React, { FC } from 'react'
import * as styles from './styles'

type SectionHeadingProps = {
  title: string
  description?: string
}

export const SectionHeading: FC<SectionHeadingProps> = ({ title, description }) => {
  return (
    <FadeInChild>
      <SmallContainer className={styles.container}>
        <Heading
          variant="h3"
          as="h2"
          mb={description && { _: '2', md: '5' }}
          className={styles.text}
        >
          {title}
        </Heading>
        {description && (
          <Text variant="bodyLarge" mb="0" className={styles.text}>
            {description}
          </Text>
        )}
      </SmallContainer>
    </FadeInChild>
  )
}
